import {CompetitionPowerRanking} from '../resources/CompetitionPowerRanking';
import {DomainEvent} from './DomainEvent';

export class PowerRankingUpdated extends DomainEvent<CompetitionPowerRanking> {}
